import utils from 'lib/utils';
import { debounce } from 'lodash';
const EnrollmentService = function () {
  this.parseEnrollment = function (model, response) {
    const enrollment = utils.sanifyJsonApiObject(response.data, response.included);
    //ensure that enrollment data is defined and not empty
    const enrollmentData = enrollment.enrollment_data;
    if (enrollmentData && Array.isArray(enrollmentData) && enrollmentData.length > 0) {
      model.data.set(enrollment.enrollment_data);
      delete enrollment.enrollment_data;
    }

    return enrollment;
  };

  this.saveData = debounce(function (model, options, dataObj) {
    if (dataObj.hasChanged()) {
      model.save(null, options);
    }
  }, 2000);
};

export default new EnrollmentService();
